import { useEffect, useState } from 'react';
import { companyInfo, navItems } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-16 md:h-20 px-4 md:px-10">
        <a href="#home" className="flex items-center gap-3 cursor-pointer shrink-0">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-stack-line text-lg md:text-xl"></i>
          </span>
          <span className={`flex flex-col leading-tight ${scrolled ? 'text-foreground-950' : 'text-foreground-950'}`}>
            <span className="font-heading font-semibold text-sm md:text-base whitespace-nowrap">
              {companyInfo.shortName}
            </span>
            <span className="text-[10px] tracking-[0.2em] text-foreground-500 hidden sm:block">
              JUNXINLAN TECH
            </span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7 lg:gap-9">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={`tel:${companyInfo.phone}`}
            className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-primary-600"></i>
            {companyInfo.phone}
          </a>
          <a
            href="#contact"
            className="px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            获取报价
          </a>
        </div>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-3 rounded-md text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="mt-3 block text-center px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            获取报价
          </a>
        </div>
      )}
    </header>
  );
}